import { LeaveStatusChit } from '@/components/chit/LeaveStatusChit';
import { TSCard } from '@/components/shared/card/Card';
import { isDateEqual } from '@/helpers/dateHelper';
import { RequestStatus } from '@/pages/team/teamMember/requests/RequestsTable.types';
import { LeaveRequestListItem } from '@/services/leaveManagement/useUpcomingLeaveListItems';
import { format } from 'date-fns';
import { FC } from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';

const formatDay = (date: Date) => format(date, 'd MMM');

const formatDateRange = (start: Date, end: Date) =>
  isDateEqual(start, end) ? formatDay(start) : `${formatDay(start)} - ${formatDay(end)}`;

export const MyScheduleLeaveRequestList: FC<{ items: LeaveRequestListItem[] }> = ({ items }) => (
  <ul className="divide-y divide-gray-200 space-y-3">
    {items.map(item => (
      <li key={item.id}>
        <TSCard className="flex items-center justify-between p-4 gap-4">
          <div className="min-w-0">
            <p className="truncate text-gray-900">{item.title}</p>
            <p className="mt-1 flex items-center gap-1.5 text-sm text-gray-500">
              <AiOutlineClockCircle aria-hidden className="shrink-0" />
              <span>{formatDateRange(item.startDate, item.endDate)}</span>
            </p>
          </div>
          {item.status !== RequestStatus.Approved && <LeaveStatusChit status={item.status} />}
        </TSCard>
      </li>
    ))}
  </ul>
);
